import Loadable from "@loadable/component";

const SizeChartPage = Loadable(
  () => import(/* webpackChunkName: "size_chart_page" */ "./sizeChart")
);

export default SizeChartPage;
